module.exports = __webpack_public_path__ + "caedd0f4d84aea55c579b3856adfa26d.jpg";